<template>
  <div class="vs-con-loading__container">
    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
      <a
        style="position: absolute; right: 30px; top: 0"
        class="vs-component vs-button vs-button-primary float-right vs-button-border"
        :href="`${BASE_DOWNLOAD_URL}template_dismantle.xlsx`"
        download>
        <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
        Download
      </a>
      <div
        class="flex flex-wrap-reverse items-center"
        style="position: absolute; right: 153px; top: 0">
        <label
          for="file-upload"
          class="vs-component vs-button vs-button-primary vs-button-border"
          @click="clearInput">
          <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" />
          Upload Data
        </label>
        <input
          id="file-upload"
          type="file"
          accept=".xlsx, .xls, .csv"
          @change="handleFile"
          ref="myFiles"
          class="hidden" />
      </div>
      <div
        class="vs-component vs-con-input-label vs-input ml-2 mb-5 vs-input-primary"
        style="white-space: normal; background: white; width: 200px">
        <v-select
          placeholder="-Select Status-"
          @input="(x) => (status = x.value)"
          :clearable="false"
          :value="getSelectValue(status, status_array)"
          :reduce="(label) => label.value"
          label="text"
          :options="status_array" />
      </div>
      <div
        v-if="status == 1"
        class="vs-component vs-con-input-label vs-input ml-2 mb-5 vs-input-primary"
        style="white-space: normal; background: white; width: 250px">
        <v-select
          class="drop-height-auto"
          multiple
          placeholder="- Select End Points -"
          :clearable="true"
          v-model="end_points"
          label="text"
          :options="dataEndPoints" />
      </div>

      <!-- ITEMS PER PAGE -->
    </div>
    <vx-card>
      <div style="width: 100%">
        <vs-table
          stripe
          @selected="handleSelected"
          pagination
          :max-items="itemsPerPage"
          :data="dataExcel">
          <!--license_plate : this.license_plate,-->
          <!--vin : this.vin,-->
          <!--end_points:endPoints,-->
          <!--device_group_code : this.device_group_id,-->
          <!--device_model_code : this.device_model_id,-->
          <!--device_type_code : this.device_type_id,-->
          <!--imei_new : this.imei_new,-->
          <!--updated_by : this.$dataLocal.UserData().name-->
          <template slot="thead" v-show="dataExcel.length > 0">
            <vs-th>Status Upload</vs-th>
            <vs-th>License Plate</vs-th>
            <vs-th>VIN</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].status">
                  <p
                    class="product-name font-medium"
                    v-if="tr.status_upload == 'loading'">
                    On Progress...
                  </p>
                  <p
                    class="product-name font-medium"
                    v-if="tr.status_upload == 'failed'"
                    style="font-weight: bold; color: red">
                    failed
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].license_plate">
                  <div
                    v-show="editing['a' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'a' + indextr"
                        placeholder="License Plate"
                        @keydown.enter="hideInput('a' + indextr)"
                        @blur="hideInput('a' + indextr)"
                        v-model="tr.license_plate"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="
                          width: auto;
                          border: 1px solid rgba(0, 0, 0, 0.2);
                        " />
                    </div>
                  </div>
                  <!--<vs-input placeholder="License Plate" style="display: none"  name="license_plate" v-model="tr.license_plate" class="mb-5 w-full" />-->
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['a' + indextr]"
                    class="product-name font-medium"
                    @click="coba('a' + indextr, 'a' + indextr)">
                    {{ tr.license_plate }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].vin">
                  <div
                    v-show="editing['b' + indextr]"
                    class="vs-component vs-con-input-label vs-input m-0 vs-input-primary"
                    style="display: none">
                    <div class="vs-con-input">
                      <input
                        :ref="'b' + indextr"
                        placeholder="VIN"
                        @keydown.enter="hideInput('b' + indextr)"
                        @blur="hideInput('b' + indextr)"
                        v-model="tr.vin"
                        type="text"
                        class="vs-inputx vs-input--input normal hasValue"
                        style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    </div>
                  </div>
                  <p
                    style="min-width: 50px; height: 20px"
                    v-show="!editing['b' + indextr]"
                    @click="coba('b' + indextr, 'b' + indextr)">
                    {{ tr.vin }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <small v-if="dataExcel.length > 0">*CLICK ON THE CELL TO CHANGE DATA</small>
    <vs-button
      class="mt-2 float-right btn-load-1 vs-con-loading__container"
      v-if="dataExcel.length > 0"
      @click="startSubmit()">
      SUBMIT
    </vs-button>
    <hr class="mt-10" />
    <vx-card
      class="shadow"
      v-if="dataSuccess.length > 0"
      style="margin-top: 20px">
      <template slot="no-body">
        <h4 style="margin: 13px; padding-top: 13px">Success Data</h4>
        <vs-table
          pagination
          ref="table"
          @selected="handleSelected"
          :data="dataSuccess">
          <template slot="thead">
            <vs-th sort-key="description">Status Upload</vs-th>
            <vs-th>License Plate</vs-th>
            <vs-th>VIN</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].status">
                  <p class="product-name font-medium" style="color: green">
                    <feather-icon
                      icon="CheckIcon"
                      style="color: green"
                      svgClasses="h-4 w-4"></feather-icon>
                    Success
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].license_plate">
                  {{ tr.license_plate }}
                </vs-td>
                <vs-td :data="data[indextr].vin">
                  {{ tr.vin }}
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </template>
    </vx-card>
  </div>
</template>

<script>
import * as REPO from '../../../repository/index'
import driver_pic from '../../../assets/images/driver.png'
import * as moment from 'moment'
import XLSX from 'xlsx'
import { BASE_DOWNLOAD_URL } from '../../../constant'

export default {
  watch: {},
  components: {},
  data() {
    return {
      BASE_DOWNLOAD_URL,
      openModal: false,
      openBulkModal: false,
      editMode: false,
      titleModal: 'Add New',
      selected: [],
      alertData: [],
      status: '',
      status_array: [
        {
          text: 'Active',
          value: 1,
        },
        {
          text: 'Suspend',
          value: 2,
        },
        {
          text: 'Inactive',
          value: 0,
        },
      ],
      dataModel: [],
      dataSuccess: [],
      dataBrand: [],
      dataVehicle: [],
      dataFleetGroup: [],
      dataDeviceGroup: [],
      dataEndPoints: [],
      dataDeviceModel: [],
      dataDeviceType: [],
      state: {},
      data: [],
      fleet_group_id: '',
      vehicle_category: '',
      end_points: [],
      fleet_group_array: [],
      fleetGroupData: [],
      category_array: [],
      dataEdit: {},
      driver_pic: driver_pic,
      editing: {},
      dataExcel: [],
      itemsPerPage: 10,
      last_page: 1,
      page: 1,
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  methods: {
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitUpdate(val, callback) {
      const self = this
      REPO.updateStatusVehicle(val, val.vin)
        .then((res) => {
          if (res.data.status == 'true') {
            self.dataSuccess.push(val)
            callback('success')
          } else {
            callback('failed')
            self.$vs.notify({
              time: 2500,
              title: 'Error',
              text: res.data.error_msg,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            })
          }
        })
        .catch((err) => {
          callback('failed')
          let datas = err.response.data
          let err_msg = ''
          let counter = 0
          for (var key in datas) {
            if (datas.hasOwnProperty(key)) {
              //
              err_msg += ' -' + datas[key]
            }
            counter++
          }
          if (counter === 0) {
            err_msg = err.message
          }
          self.$vs.notify({
            time: 2500,
            title: 'Error',
            text: err_msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
    startSubmit() {
      let { status, end_points } = this
      if (status == 2 || status == 0) {
        this.loadingBtnStart('btn-load-1')
        // let tmp = this.dataExcel
        this.dataExcel.forEach((x) => {
          x.status = status
          x.status_upload = ''
        })
        // this.dataExcel=tmp;
        this.submit()
      } else if (status == 1 && end_points.length > 0) {
        this.loadingBtnStart('btn-load-1')
        // let tmp = this.dataExcel
        this.dataExcel.forEach((x) => {
          x.status = status
          x.status_upload = ''
        })
        // this.dataExcel=tmp;
        this.submit()
      } else {
        this.$toast.error('Please complete the field')
      }
    },
    submit() {
      //
      const self = this
      let endPoints
      if (this.end_points.length > 0) {
        endPoints = this.end_points[0].value
      }

      if (this.end_points.length > 1) {
        this.end_points.forEach((x, i) => {
          if (i > 0) endPoints += ',' + x.value
        })
      }
      //
      let tmp = this.dataExcel.filter((x) => {
        return x.status_upload != 'failed'
      })
      if (tmp.length > 0) {
        self.dataExcel[0].status_upload = 'loading'
        //
        tmp[0].status_upload = 'loading'
        let sementara = JSON.parse(JSON.stringify(this.dataExcel[0]))

        tmp[0].suspend_by = self.$dataLocal.UserData().name
        tmp[0].status = this.status
        let data_kirim = JSON.parse(JSON.stringify(tmp[0]))
        if (this.status == 1) {
          data_kirim.end_points = endPoints
        }
        //

        self.submitUpdate(data_kirim, (callback) => {
          self.dataExcel.splice(0, 1)
          if (callback == 'success') {
            //
          } else {
            sementara.status_upload = 'failed'
            self.dataExcel.push(sementara)
            //
          }
          self.submit()
        })
      } else {
        this.loadingBtnStop('btn-load-1')
      }
    },
    hideInput(val) {
      this.editing[val] = false
    },
    coba(val, dua) {
      this.$set(this.editing, val, true)
      //
      this.$nextTick(() => {
        this.$refs[dua][0].focus()
      })
      // let tmp = this.$refs[val][0].style;
      //
      //    this.$refs[val][0].style = "display:block"
      //    this.$nextTick(() => this.$refs[val][0].focus());
      //    this.$refs[val][0].onblur=function () {
      //
      //        this.$refs[val][0].style = "display:none"
      //    }
    },
    clearInput() {
      document.getElementById('file-upload').value = ''
      this.dataSuccess = []
    },
    handleFile() {
      //
      //
      this.prosesData(this.$refs.myFiles.files)
    },
    formatDate(val) {
      return moment(val).format('DD MMMM YYYY')
    },
    statusDescription(val) {
      if (val == 1) {
        return 'Active'
      } else {
        return 'Non Active'
      }
    },
    successUpload(val) {
      //
      let file = document.querySelectorAll('input[type=file]')
      //
      this.prosesData(file[0].files)
    },
    getHeaderRow(sheet) {
      var headers = [],
        range = XLSX.utils.decode_range(sheet['!ref'])
      var C,
        R = range.s.r /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ] /* find the cell in the first row */
        var hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    fixdata(data) {
      var o = '',
        l = 0,
        w = 10240
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        )
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
      return o
    },
    workbook_to_json(workbook) {
      var result = {}
      workbook.SheetNames.forEach(function (sheetName) {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        )
        if (roa.length > 0) {
          result[sheetName] = roa
        }
      })
      return result
    },
    prosesData(e) {
      var files = e
      for (var i = 0, f = files[i]; i != files.length; ++i) {
        var reader = new FileReader(),
          name = f.name
        reader.onload = (e) => {
          var results,
            data = e.target.result,
            fixedData = this.fixdata(data),
            workbook = XLSX.read(btoa(fixedData), { type: 'base64' }),
            firstSheetName = workbook.SheetNames[0],
            worksheet = workbook.Sheets[firstSheetName]
          this.state.headers = this.getHeaderRow(worksheet)
          results = XLSX.utils.sheet_to_json(worksheet)

          results.forEach((x) => {
            x.status_upload = ''
            // x.imei_obd_number = x.imei_obd_number.toString();
            // x.simcard_number = x.simcard_number.toString();
          })
          this.state.tickets = results
          this.dataExcel = this.state.tickets
          //
        }
        reader.readAsArrayBuffer(f)
      }
    },
    handleSelected(tr) {
      this.editMode = true
      this.titleModal = 'Update Data'
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.openModal = true
    },
    closeModal() {
      this.openModal = false

      this.openBulkModal = false
    },
    submitModal() {
      this.openModal = false

      this.openBulkModal = false
    },
    getStatusColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },

    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue
        }
        return obj
      })
      return formattedData
    },
  },
  mounted() {
    //
    REPO.getListEndPoints()
      .then((res) => {
        // this.dataDeviceType = res.data.data;
        let tmp = res.data.data
        this.dataEndPoints = []
        tmp.forEach((x) => {
          this.dataEndPoints.push({
            text: x.attributes.code,
            value: x.attributes.code,
          })
        })
      })
      .catch((err) => {
        //
      })
    REPO.getListVehicleCategory()
      .then((res) => {
        // this.dataDeviceType = res.data.data;
        let tmp = res.data.data
        this.category_array = []
        tmp.forEach((x) => {
          this.category_array.push({ text: x, value: x })
        })
      })
      .catch((err) => {
        //
      })
    REPO.getListFleetGroup().then((res) => {
      let tmp = res.data.data
      this.fleet_group_array = []
      tmp.forEach((x) => {
        this.fleet_group_array.push({
          value: x.id,
          text: x.fleet_group_name,
        })
      })
    })
    // this.$vs.loading({
    //     container: '#data-list-list-view',
    //     scale: 1
    // })
    this.isMounted = true
  },
}
</script>

<style lang="scss"></style>
